import $ from "jquery";

$(document).on('click', '.js-favorite-toggle', function (e) {
  e.preventDefault();

  const $btn = $(this);

  // защита от повторных кликов
  if ($btn.data('loading')) return;

  const type = $btn.data('type');          // "order" | "workshop"
  const id = $btn.data('id');              // числовой id
  const isFavorited = Number($btn.data('favorited')) === 1;

  // ВАЖНО: твой контроллер ждёт type = "order" / "workshop"
  // (в index у тебя почему-то "orders/workshops" — это отдельно)
  const payload = { type: type, id: id };

  // включаем "loading"
  setLoading($btn, true);

  if (!isFavorited) {
    // ADD -> FavoriteController@store (POST /favorites)
    $.ajax({
      url: '/favorites',
      method: 'POST',
      data: payload,
      dataType: 'json'
    })
      .done(function (res) {
        // успех
        setFavoritedUI($btn, true);
      })
      .fail(function (xhr) {
        handleFavoriteError(xhr);
      })
      .always(function () {
        setLoading($btn, false);
      });

  } else {
    // REMOVE -> FavoriteController@destroy (DELETE /favorites/{id})
    // Чтобы было максимально совместимо: POST + _method=DELETE
    $.ajax({
      url: '/favorites/' + id,
      method: 'POST',
      data: { type: type, _method: 'DELETE' },
      dataType: 'json'
    })
      .done(function (res) {
        setFavoritedUI($btn, false);
      })
      .fail(function (xhr) {
        handleFavoriteError(xhr);
      })
      .always(function () {
        setLoading($btn, false);
      });
  }
});

function setLoading($btn, isLoading) {
  $btn.data('loading', isLoading);

  // UI: дизейбл, можно добавить спиннер/класс
  $btn.prop('disabled', isLoading);
  $btn.toggleClass('is-loading', isLoading);
}

function setFavoritedUI($btn, favorited) {
  // записываем новое состояние
  $btn.data('favorited', favorited ? 1 : 0);

  // текст кнопки
  $btn.text(favorited ? 'Убрать' : 'В избранное');

  // можно менять класс (иконка, цвет)
  $btn.toggleClass('is-favorited', favorited);
}

function handleFavoriteError(xhr) {
  // можешь разобрать 401/419/422 красиво
  if (xhr.status === 401) {
    alert('Нужно войти в аккаунт, чтобы добавлять в избранное.');
    return;
  }
  if (xhr.status === 419) {
    alert('Сессия истекла. Обнови страницу и попробуй снова.');
    return;
  }

  let msg = 'Ошибка. Попробуй ещё раз.';
  try {
    const json = xhr.responseJSON;
    if (json?.error) msg = json.error;
  } catch (e) {}

  alert(msg);
}
